import { StepComponentName } from '../ActivationFlow/constants/componentNames';
// Pre-account step components
import MeetAccountableBanking from '../Onboarding/steps/MeetAccountableBanking.component';
import PeppolBanking from '../Onboarding/steps/PeppolBankingStep';
import AutomaticallyReserveTaxes from '../Onboarding/steps/AutomaticallyReserveTaxes.component';
import FullTransparency from '../Onboarding/steps/FullTransparency.component';
// fixed by adding lazy import in useWalletOnboardingModal file
// ESLint can't detect lazy imports in static analysis
import OnboardingForm from '../Onboarding/steps/OnboardingForm.component';
import FinanzamtDocUploader from '../Onboarding/steps/FinanzamtDocUploader.component';
import ConfirmIdentity from '../Onboarding/steps/ConfirmIdentity.component';

// Post-account step components
import InitActivationStep from '../ActivationFlow/steps/InitActivationStep';
import HowIsIntegratedStep from '../ActivationFlow/steps/HowIsIntegratedStep';
import TaxesDescriptionStep from '../ActivationFlow/steps/TaxesDescriptionStep';
import AccIbanOnInvoicesStep from '../ActivationFlow/steps/AccIbanOnInvoicesStep';
import IssueCardStep from '../ActivationFlow/steps/IssueCardStep';
import CardDesignStep from '../ActivationFlow/steps/IssueCardStep/CardDesignStep';
import YourCardReadyStep from '../ActivationFlow/steps/YourCardReadyStep';
import CardToWalletStep from '../ActivationFlow/steps/CardToWalletStep';
import TopUpStep from '../ActivationFlow/steps/TopUpStep';
import ReadyToGoStep from '../ActivationFlow/steps/ReadyToGoStep';

/**
 * Component registry - centralizes all step component imports
 * Separated from stepDefinitions.ts to break circular dependencies
 */
export const STEP_COMPONENTS: Record<
  StepComponentName,
  React.ComponentType<any>
> = {
  // Pre-account (sign up) steps
  [StepComponentName.MeetAccountableBanking]: MeetAccountableBanking,
  [StepComponentName.PeppolBanking]: PeppolBanking,
  [StepComponentName.AutomaticallyReserveTaxes]: AutomaticallyReserveTaxes,
  [StepComponentName.FullTransparency]: FullTransparency,
  [StepComponentName.OnboardingForm]: OnboardingForm,
  [StepComponentName.FinanzamtDocUploader]: FinanzamtDocUploader,
  [StepComponentName.ConfirmIdentity]: ConfirmIdentity,

  // Post-account (activation) steps
  [StepComponentName.InitActivationStep]: InitActivationStep,
  [StepComponentName.HowIsIntegratedStep]: HowIsIntegratedStep,
  [StepComponentName.TaxesDescriptionStep]: TaxesDescriptionStep,
  [StepComponentName.AccIbanOnInvoicesStep]: AccIbanOnInvoicesStep,
  [StepComponentName.IssueCardStep]: IssueCardStep,
  [StepComponentName.CardDesignStep]: CardDesignStep,
  [StepComponentName.YourCardReadyStep]: YourCardReadyStep,
  [StepComponentName.CardToWalletStep]: CardToWalletStep,
  [StepComponentName.TopUpStep]: TopUpStep,
  [StepComponentName.ReadyToGoStep]: ReadyToGoStep,
};
